/* eslint-disable prefer-destructuring */

export const isValidEmail = (email) => {
  if (
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(
      email,
    )
  ) {
    return true;
  }
  return false;
};

const normalize = (str) =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

// Substrings unique to rough/DIY estimate line items, robust to spelling variants
const ROUGH_ESTIMATE_PATTERNS = [
  'client generated rough estimate', // matches both GUESTIMATE and GUESSIMATE spellings
  'rough estimate only',
  'site visit required',
];

export const getEstimateInvoiceStatus = (estimate) => {
  if (!estimate?.accepted) return false;
  return !estimate.lines?.some((item) => {
    const name = normalize(item.name);
    const desc = normalize(item.description);
    return ROUGH_ESTIMATE_PATTERNS.some((p) => name.includes(p) || desc.includes(p));
  });
};

/**
 * @name separateStreetAndRoute
 * @description This function is used to separate the digits from the string
 * @param {string} street
 * @returns {object} street_number, route
 * */

export const separateStreetAndRoute = (street) => {
  if (!street) return { street_number: '', route: '' };
  let digits = '';
  let rest = '';

  /* eslint-disable no-restricted-globals */
  for (let i = 0; i < street.length; i++) {
    if (!isNaN(street[i])) {
      digits += street[i];
    } else {
      rest = street.substring(i);
      break;
    }
  }

  return {
    street_number: digits.trim(),
    route: rest.trim(),
  };
};

/**
 * @name getCloudFlareImageUrl
 * @param {string} imageId
 * @returns {string} cloudFlareImageUrl
 * @description Get the cloud flare image url for the given imageId
 */
export const getCloudFlareImageUrl = (imageId) => {
  const CLOUD_FLARE_URL = 'https://imagedelivery.net/ymzsI53Kh75k7cihPmB4TQ';
  return `${CLOUD_FLARE_URL}/${imageId}/public`;
};
